import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnInit,
} from '@angular/core';


@Component({
  selector: 'nym-card-activity-listing-header',
  templateUrl: './card-activity-listing-header.component.html',
  styleUrls: ['./card-activity-listing-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardActivityListingHeaderComponent implements OnInit {

  @HostBinding('class.nym-card-activity-listing-header')
  protected get classes(): boolean { return true; }

  @Input()
  public title: string;

  @Input()
  public description: string;

  constructor() { }

  public ngOnInit(): void { }

}
